/**
 * Set and get cookies
 */
class Cookies {
  /**
   *
   * @param {string} cname cookie name
   * @param {mixed} cvalue cookie value
   * @param {number} exdays expiration
   */
  setCookie(cname, cvalue, exdays) {
    let d = new Date();
    exdays = typeof exdays === "undefined" ? 365 : exdays;
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  /**
   *
   * @param {string} cname cookie name
   */
  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}

export default new Cookies();
